export enum HandsontableStylingCondition {
  OFFSET_ROW_SHOULD_BE_THE_SAME = "OFFSET_ROW_SHOULD_BE_THE_SAME"
}
